import { MainContainerTheme } from "Themes/Metrics";
import styled from "styled-components";

export const MainContainer = styled(MainContainerTheme)``;

const styles = {
    container: {
        padding: 20,
    },
    mainContainer: {
        border: "solid 2px lightgray",
        padding: 20,
        borderRadius: "10px",
        width: "50%",
        margin: "auto"
    },
    failureContainer: {
        border: "solid 2px red"
    }
}

export default styles;